import React from "react"
import types from "prop-types"
import { CheckmarkCircleIcon } from "shared/icons"
import Tooltip, { TOP_CENTER } from "shared/Tooltip"

const ActivityCompletionIndicator = ({ total, open, label }) => {
  if (!total) return null

  const completed = total - open
  const tooltipText = `${completed} of ${total} ${label}`

  return (
    <div className="flex justify-center">
      <Tooltip text={tooltipText} position={TOP_CENTER}>
        {open === 0
          ? <CheckmarkCircleIcon className="relative w-5 h-5 shrink-0" />
          : <div className="relative w-5 h-5 shrink-0 border rounded-full" />}
      </Tooltip>
    </div>
  )
}

ActivityCompletionIndicator.propTypes = {
  total: types.number.isRequired,
  open: types.number.isRequired,
  label: types.string.isRequired,
}

export default ActivityCompletionIndicator
